import React from 'react';

import AuthCallbackPage from './pages/Auth/Login';
import { MobileSessionTransitionPage } from './pages/Auth/MobileSessionTransition';
import AuthPartnerLinkPage from './pages/Auth/PartnerLink';
import { ChangePassword } from './pages/ChangePassword';
import { ForgotPassword } from './pages/ForgotPassword';
import MarriottBonvoyAuthorizePage from './pages/MarriottBonvoyAuthorize';
import MarriottBonvoyLinkPage from './pages/MarriottBonvoyLink';
import { MlifeActivationWrapper } from './pages/MlifeActivation';
import { ResetPassword } from './pages/ResetPassword';
import { SignIn } from './pages/SignIn';
import { SignInOrJoin } from './pages/SignInOrJoin';
import { SignUp } from './pages/SignUp';
import { IDENTITY_WIDGET_PATHS } from './utils/constants';

export const routes = {
  [IDENTITY_WIDGET_PATHS.SignInOrJoin]: function SignInOrJoinPage() {
    return <SignInOrJoin />;
  },
  [IDENTITY_WIDGET_PATHS.SignIn]: function SignInPage() {
    return <SignIn />;
  },
  [IDENTITY_WIDGET_PATHS.SignUp]: function SignUpPage() {
    return <SignUp />;
  },
  [IDENTITY_WIDGET_PATHS.ForgotPassword]: function ForgotPasswordPage() {
    return <ForgotPassword />;
  },
  [IDENTITY_WIDGET_PATHS.ResetPassword]: function ResetPasswordPage({ token }: { token?: string }) {
    return <ResetPassword token={token} />;
  },
  [IDENTITY_WIDGET_PATHS.ChangePassword]: function ChangePasswordPage() {
    return <ChangePassword />;
  },
  [IDENTITY_WIDGET_PATHS.MlifeActivation]: function MlifeActivationPage() {
    return <MlifeActivationWrapper />;
  },
  [IDENTITY_WIDGET_PATHS.OktaRedirect]: function OktaRedirectPage() {
    return <AuthCallbackPage />;
  },
  [IDENTITY_WIDGET_PATHS.AuthMobile]: function AuthMobilePage() {
    return <MobileSessionTransitionPage />;
  },
  [IDENTITY_WIDGET_PATHS.PartnerLink]: function PartnerLinkPage() {
    return <AuthPartnerLinkPage />;
  },
  [IDENTITY_WIDGET_PATHS.MarriottBonvoyAuthorize]: function MarriottBonvoyAuthorizeInterstitialPage() {
    return <MarriottBonvoyAuthorizePage />;
  },
  [IDENTITY_WIDGET_PATHS.MarriottBonvoyPartnerLink]: function MarriottBonvoyPartnerLinkPage() {
    return <MarriottBonvoyLinkPage />;
  },
};
